export default __webpack_public_path__ + "static/media/TF_06.d1306ae9.png";